export default "__VITE_ASSET__Dt1CHc21__"